import type { DriverRecord } from '../../../types'
import type { RowAction } from '../../../components/ui/RowActionsMenu'
import { DriverCard } from './DriverCard'
// import { DRIVER_MIN_WIDTH } from './driversLayout'

type DriversListProps = {
  drivers: DriverRecord[]
  /** Reflects the active filters rather than the size of the whole roster. */
  count: number
  filtersOpen?: boolean
  onToggleFilters?: () => void
  buildActions: (driver: DriverRecord) => RowAction[]
}

export const DriversList = ({
  drivers,
  count,
  buildActions,
}: DriversListProps) => (
  <div className="flex min-h-0 w-full flex-1 flex-col items-end gap-[7px]">
    <div className="flex w-full items-center justify-between gap-[16px]">
      <h2 className="whitespace-nowrap font-host text-[16px] font-semibold leading-[1.5] tracking-[-0.352px] text-black">
        Available Drivers({count})
      </h2>

     
    </div>

    {/* <div className="w-full overflow-x-auto"> */}
    <div className="min-h-0 w-full flex-1 overflow-x-hidden pr-[4px] lg:overflow-y-auto lg:overscroll-contain">
      <div className="flex w-full min-w-0 flex-col items-center gap-[9px]">
        {drivers.length === 0 ? (
          <p className="w-full rounded-[8px] bg-white py-[40px] text-center font-host text-[16px] font-normal leading-normal text-dash-col-head">
            No drivers match the current filters.
          </p>
        ) : (
          drivers.map((driver) => (
            <DriverCard
              key={driver.id}
              actions={buildActions(driver)}
              driver={driver}
            />
          ))
        )}
      </div>
    </div>
  </div>
)
